import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import axios from 'axios';
import Steps from "../../components/steps";
import config from "../../config/config";
// import Steps from "../components/steps";

export async function loader({ params }) {
  return { payment : params.paymentId };
}


const useCustomSearchParams = () => {
  const [search, setSearch] = useSearchParams();
  const searchAsObject = Object.fromEntries(
    new URLSearchParams(search)
  );
  return [searchAsObject, setSearch];
};

export default function Waiting() {

  const setIntervalRef = useRef();

  const [search, setSearch] = useCustomSearchParams();

  const [steps, setSteps] = useState([
    { title: 'Pago Realizado', description: 'Recibimos tu pago', status: 'completed' },
    { title: 'Seleccionando Producto', description: 'Estamos procesando la entrega de tu producto', status: 'pending' },
    { title: 'Producto Entregado', description: 'Producto Entregado', status: 'pending' },
  ]);


  const doCheck = (paymentId) => {
    if (paymentId) {
      // axios.get(`https://api.winfas.com.ar/payment/status/` + paymentId).then(res => {
      axios.get(config.API.BASE_URI + `payment/status/` + paymentId).then(res => {
      // axios.get(`https://infas.pragmatia.com/payment/status/` + paymentId).then(res => {
      // axios.get(`http://192.168.1.12:8888/payment/status/` + paymentId).then(res => {
        if (res && res.data && res.data.status) {
          // console.log(res.data.status)
          if (res.data.status === 'pending' || res.data.status === 'in-progress') {
            let newSteps = [ ...steps ];
            newSteps[0].status = 'completed';
            newSteps[1].status = 'in-progress';
            newSteps[2].status = 'pending';
            newSteps[1].description = 'Estamos procesando la entrega de tu producto (' + res.data.status + ')';
            setSteps(newSteps);
          } else if (res.data.status === 'completed' || res.data.status === 'errored') {
            clearInterval(setIntervalRef.current);
            let newSteps = [ ...steps ];
            newSteps[0].status = 'completed';
            newSteps[1].status = 'completed';
            newSteps[2].status = res.data.status;
            if (res.data.status === 'errored') {
              newSteps[2].title = 'Producto No Entregado';
              newSteps[2].description = 'Ocurrió un error, por favor comunicate al tel. 0800 123 4455';
            }
            console.log(newSteps);
            setSteps(newSteps);
          } else if (res.data.status === 'NOT-FOUND') {
            clearInterval(setIntervalRef.current);
          }
        }
        console.log(res);
      }).catch(err => {
        console.log(err);
      });
    }
  };



  useEffect(() => {
    // console.log('a')
    const intervalId = setInterval(() => {
      doCheck(search.external_reference);
    }, 1000);

    // this is where the interval ID is saved in the ref object
    setIntervalRef.current = intervalId;
    return () => {
      clearInterval(setIntervalRef.current);
    };
  }, []);


  return (
    <div className="sm:container sm:mx-auto my-5 center ms-5">
      <Steps steps={steps} />
    </div>
  );
}